import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { DietsListDietType } from 'src/app/core/model/api-response/plans-response-model';
import {
  Calorie,
  PredefinedDiet,
} from 'src/app/core/model/generate-response-model';

@Injectable()
export class GenerateShared {
  constructor() {}

  private _isCanceling = false;
  private _cancelDay = 0;
  // private _selectedDietType: PredefinedDiet;
  // private _selectedDietTypeTemp: PredefinedDiet;
  private _selectedDietType: DietsListDietType;
  private _selectedDietTypeTemp: DietsListDietType;
  private _previousUrl = '';

  public get selectedDietTypeTemp(): DietsListDietType {
    return this._selectedDietTypeTemp;
  }
  public set selectedDietTypeTemp(value: DietsListDietType) {
    this._selectedDietTypeTemp = value;
  }

  public get selectedDietType(): DietsListDietType {
    return this._selectedDietType;
  }
  public set selectedDietType(value: DietsListDietType) {
    this._selectedDietType = value;
  }

  public get previousUrl(): string {
    return this._previousUrl;
  }
  public set previousUrl(value: string) {
    this._previousUrl = value;
  }

  // public get selectedDietTypeTemp(): PredefinedDiet {
  //   return this._selectedDietTypeTemp;
  // }
  // public set selectedDietTypeTemp(value: PredefinedDiet) {
  //   this._selectedDietTypeTemp = value;
  // }

  // public get selectedDietType(): PredefinedDiet {
  //   return this._selectedDietType;
  // }
  // public set selectedDietType(value: PredefinedDiet) {
  //   this._selectedDietType = value;
  // }

  public get cancelDay() {
    return this._cancelDay;
  }
  public set cancelDay(value) {
    this._cancelDay = value;
  }

  public get isCanceling() {
    return this._isCanceling;
  }
  public set isCanceling(value) {
    this._isCanceling = value;
  }

  private nextPageObs = new BehaviorSubject<boolean>(false);
  nextPageObs$ = this.nextPageObs.asObservable();

  private generateActivateButtonObs = new BehaviorSubject<number>(-1);
  generateActivateButtonObs$ = this.generateActivateButtonObs.asObservable();

  private generateDeactivateButtonObs = new BehaviorSubject<number>(-1);
  generateDeactivateButtonObs$ =
    this.generateDeactivateButtonObs.asObservable();

  private closeOverviewDetailObs = new BehaviorSubject<boolean>(false);
  closeOverviewDetailObs$ = this.closeOverviewDetailObs.asObservable();

  private closeOverviewDetailAndChangeDifficultyObs =
    new BehaviorSubject<boolean>(false);
  closeOverviewDetailAndChangeDifficultyObs$ =
    this.closeOverviewDetailAndChangeDifficultyObs.asObservable();

  private showPopupObs = new BehaviorSubject<boolean>(false);
  showPopupObs$ = this.showPopupObs.asObservable();

  private calories: Calorie[];
  private _calorie: string;
  private _specialTypeStartDate: Date;
  private _weight: number;
  private _activityLevel: number;
  private _activityLevelTemp: number;
  private _isVegeterian: boolean;
  private diseases = [];
  private hatedFoods = [];
  private fastingDays = [];
  private _difficulty: number;
  private _startDay: number;
  private _goal: string;
  public startDays = [];

  getCalories() {
    return this.calories;
  }

  setCalories(c: Calorie[]) {
    this.calories = [];
    c.forEach((calorie) => {
      this.calories.push(
        new Calorie(calorie.difficulty, calorie.amount, calorie.suitable)
      );
    });
  }

  getDiseases() {
    return this.diseases;
  }

  setDiseases(d: any[]) {
    this.diseases = d;
  }

  getHatedFoods() {
    return this.hatedFoods;
  }

  setHatedFoods(hf: any[]) {
    this.hatedFoods = hf;
  }

  getFastingDays() {
    return this.fastingDays;
  }

  setFastingDays(fd: any[]) {
    this.fastingDays = fd;
  }

  nextPage() {
    this.nextPageObs.next(true);
    this.nextPageObs.next(false);
  }

  generateActivateButton(id: number) {
    this.generateActivateButtonObs.next(id);
    this.generateActivateButtonObs.next(-1);
  }

  generateDeactivateButton(id: number) {
    this.generateDeactivateButtonObs.next(id);
    this.generateDeactivateButtonObs.next(-1);
  }

  closeOverviewDetail() {
    this.closeOverviewDetailObs.next(true);
    this.closeOverviewDetailObs.next(false);
  }

  closeOverviewDetailAndChangeDifficulty() {
    this.closeOverviewDetailAndChangeDifficultyObs.next(true);
    this.closeOverviewDetailAndChangeDifficultyObs.next(false);
  }

  showPopup() {
    this.showPopupObs.next(true);
    this.showPopupObs.next(false);
  }

  public get specialTypeStartDate(): Date {
    return this._specialTypeStartDate;
  }
  public set specialTypeStartDate(value: Date) {
    this._specialTypeStartDate = value;
  }
  public get calorie(): string {
    return this._calorie;
  }
  public set calorie(value: string) {
    this._calorie = value;
  }
  public get isVegeterian(): boolean {
    return this._isVegeterian;
  }
  public set isVegeterian(value: boolean) {
    this._isVegeterian = value;
  }
  public get weight(): number {
    return this._weight;
  }
  public set weight(value: number) {
    this._weight = value;
  }
  public get activityLevel(): number {
    return this._activityLevel;
  }
  public set activityLevel(value: number) {
    this._activityLevel = value;
  }
  public get activityLevelTemp(): number {
    return this._activityLevelTemp;
  }
  public set activityLevelTemp(value: number) {
    this._activityLevelTemp = value;
  }
  public get difficulty(): number {
    return this._difficulty;
  }
  public set difficulty(value: number) {
    this._difficulty = value;
  }
  public get startDay(): number {
    return this._startDay;
  }
  public set startDay(value: number) {
    this._startDay = value;
  }
  public get goal(): string {
    return this._goal;
  }
  public set goal(value: string) {
    this._goal = value;
  }
}
